import * as React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { BackButton } from '@/components/atoms/BackButton';

export const Route = createFileRoute('/disclaimer')({
  component: Disclaimer,
});

function Disclaimer() {
  return (
    <div className="main-content">
      <div className="p-4">
        <BackButton />
      </div>
      <div className="p-4">
        <h1 className="text-3xl font-bold">Website Disclaimer</h1>
          <p className="mt-4">
            All website contents copyright © 2025 Excelera Pty Ltd. All rights reserved. Prices, configurations, promotions, and availability may change without notice.
            Excelera Pty Ltd cannot be held responsible for pricing discrepancies due to errors in website functionality.
          </p>
          <p className="mt-4">
            All product photos are for illustrative purposes only. Photos displayed on website may contain optional items that are not included in the default configuration for that system.
          </p>
          <p className="mt-4">
            Shipping charges are not shown. Excelera Pty Ltd cannot be held responsible for errors in photography or typography. For hard drives, GB means 1 billion bytes and accessible capacity may vary depending on configuration. For CD-ROM, DVD-ROM, CD-RW, and DVD+RW/+R drive(s), maximum data transfer rates may vary and discs created with these drives may not be compatible with all drives and players. For modems and network cards/hardware, maximum achievable data transfer rates may vary.
          </p>
          <p className="mt-4">
            Award(s) and quote(s) listed do not necessarily pertain to a specific system or configuration. All registered trademarks and trademarks are the property of their respective owners. Actual case may vary in design.
          </p>
          <p className="mt-4">
            Intel, Intel Inside, the Intel Inside logo, Intel Centrino, the Intel Centrino logo, Pentium, Pentium III Xeon, Intel Xeon, Itanium, Intel SpeedStep, and Celeron are trademarks or registered trademarks of Intel Corporation or its subsidiaries in the United States and other countries.
          </p>
          <p className="mt-4">
            AMD, Athlon Athlon 64, Athlon 64 X2, Sempron are trademarks of Advanced Micro Devices.
          </p>
          <p className="mt-4">
            Excelera Pty Ltd may use third-party advertising companies to serve ads on its behalf. These companies may employ cookies and action tags (also known as single pixel gifs or web beacons) to measure advertising effectiveness. Any information that these third parties collect via cookies and action tags is completely anonymous. Shipping, handling and any applicable taxes or customs charged are not included. Such charges will vary depending on purchaser's mailing address and method they choose to receive their copy of Half-Life 2 (i.e.; downloads vs. land delivery).	
          </p>
        </div>
    </div>
  );
}
